import {selectConstructionPlanEntries} from "../../../../redux/reducers/privateStateReducer/selectors";
import {selectPendingBuildings} from "../../../../redux/reducers/sharedStateReducer/selectors";
import {findConstructionUndoConflict} from "../findConstructionUndoConflict";
import {buildConstructionPlanningViewState} from "./buildConstructionPlanningViewState";

/**
 * Что снимает с плана двойной клик по ячейке — по тем же правилам, что
 * точечная отмена стройки своего хода (GameScene.tryUndoConstructionOnHex):
 *  - снимается ВЕРХНЯЯ запись ячейки (спецстроение на запланированном квартале
 *    раньше самого квартала);
 *  - нельзя снять запись, без которой не встала бы запланированная позже
 *    (findConstructionUndoConflict на виде планирования: казарма у
 *    запланированного квартала, дорога дальше по запланированной дороге).
 *
 * Возвращает null (на ячейке ничего не запланировано) или {entry,
 * conflictEntry}: conflictEntry — запись, которую нужно снять раньше.
 */
export const findConstructionPlanUndo = (state, hexKey) => {
  const entries = selectConstructionPlanEntries(state);
  const index = entries.findLastIndex((entry) => entry.hexKey === hexKey);
  if (index === -1) {
    return null;
  }

  const viewState = buildConstructionPlanningViewState(state, {brushToken: null});
  if (!viewState) {
    return {entry: entries[index], conflictEntry: null};
  }
  // Отложенные строения вида — записи плана в том же порядке
  const pendingBuildings = selectPendingBuildings(viewState);
  const conflict = findConstructionUndoConflict(viewState, pendingBuildings[index]);
  return {
    entry: entries[index],
    conflictEntry: conflict ? entries[pendingBuildings.indexOf(conflict.building)] : null,
  };
};
